module.exports = __webpack_public_path__ + "media/images/mobile/home/tag_w-8cda596dda3a409c50c6b56759cc44c5.png";